import { Col, Row } from 'react-bootstrap'
import CategoryCard from './CategoryCard'
import mobilario from '../../../assets/img/categories/01-mobiliario.webp'
import salones from '../../../assets/img/categories/04-lugares.webp'
import decor from '../../../assets/img/categories/10-decoracion.webp'
import floristas from '../../../assets/img/categories/11-floreria.webp'
import fotografos from '../../../assets/img/categories/03-fotoyvideo.webp'
import musica from '../../../assets/img/categories/06-musica-dj.webp'
import alimentos from '../../../assets/img/categories/02-banquete.webp'
import meseros from '../../../assets/img/categories/08-personal-servicio.webp'
import planners from '../../../assets/img/categories/07-organizacion-evento.webp'
import coctels from '../../../assets/img/categories/09-bebidas.webp'
// import MyModal from '../../common/MyModal'
// import useModal from '../../../hooks/useModal' // construction modal hook
import { useNavigate } from 'react-router-dom'
const Category = () => {
  //const { showModal, handleShowModal, handleCloseModal } = useModal() // custom hook for modal use
  const navigate = useNavigate()

  const cardContents: { image: string; cardName: string }[] = [
    {
      image: salones,
      cardName: 'Lugares',
    },
    {
      image: mobilario,
      cardName: 'Mobiliario',
    },
    {
      image: decor,
      cardName: 'Decoración',
    },
    {
      image: floristas,
      cardName: 'Florería',
    },
    {
      image: fotografos,
      cardName: 'Foto & Video',
    },
    {
      image: musica,
      cardName: 'Música',
    },
    {
      image: alimentos,
      cardName: 'Banquete',
    },
    {
      image: meseros,
      cardName: 'Personal de Servicio',
    },
    {
      image: planners,
      cardName: 'Organización Evento',
    },
    {
      image: coctels,
      cardName: 'Bebidas',
    },
  ]

  return (
    <section className="bg-body-tertiary pt-5">
      <div className="hide">
        <Row className="align-items-center hide-o">
          <Col className="text-center mb-5">
            <h2 className="text-primary mb-2">Busca por categorías</h2>
            <div className="fs-9 text-break">
              Encuentra cientos de proveedores en nuestras diferentes categorías
            </div>
          </Col>
        </Row>
      </div>
      <div className="container-lg px-xxl-20">
        <Row xs={2} md={5} lg={5}>
          {cardContents.map((cardContent, index) => {
            const handleCategoryClick = () => {
              navigate(
                `/home/searchpage?category=${encodeURIComponent(
                  // change depending on route of search page
                  cardContent.cardName
                )}`
              )
            }

            return (
              <Col key={index} className="d-flex justify-content-center">
                <div
                  style={{ textDecoration: 'none', cursor: 'pointer' }}
                  onClick={handleCategoryClick}
                >
                  <CategoryCard image={cardContent.image} cardName={cardContent.cardName} />
                </div>
              </Col>
            )
          })}
        </Row>
      </div>
      <div className="hide-of">
        <Row className="align-items-center hide-of">
          <Col className="text-center">
            <h2 className="text-primary opacity-50">... y mucho más</h2>
          </Col>
        </Row>
      </div>
    </section>
  )
}
export default Category
